export interface Article {
  id: string;
  title: string;
  category: string;
  summary: string;
  content: string[];
  image: string;
  date: string;
  author: string;
  relatedIds: string[];
}

export const articles: Article[] = [
  {
    id: 'art-001',
    title: '2025年最值得期待的十部国产电影',
    category: 'movie',
    summary: '新的一年有哪些国产大片值得走进影院？我们为你盘点2025年最令人期待的十部国产电影，从科幻巨制到温情文艺，总有一部适合你。',
    content: [
      '随着中国电影工业的不断成熟，2025年的国产电影市场可谓精彩纷呈。从年初到岁末，众多备受期待的影片将陆续与观众见面。',
      '科幻题材持续发力，《流浪地球3》作为系列终章，将带来更加宏大的视觉奇观和深刻的人文思考。导演郭帆表示，这一部将把"带着地球去流浪"的浪漫主义推向极致。',
      '动画电影方面，《哪吒之魔童闹海》承载着观众对国漫崛起的无限期待。前作以50亿票房刷新纪录，续集能否再创辉煌，牵动着无数影迷的心。',
      '现实主义题材同样不容忽视。多位知名导演将镜头对准普通人的生活，用细腻的笔触描绘时代变迁中的个体命运。',
      '此外，悬疑、动作、喜剧等类型片也各展风采。国产电影正在以更加多元化的面貌，为观众带来丰富的精神食粮。',
    ],
    image: 'https://readdy.ai/api/search-image?query=Cinema%20interior%20with%20red%20velvet%20seats%20and%20large%20blank%20movie%20screen%2C%20warm%20theater%20lighting%2C%20elegant%20and%20classic%20atmosphere%2C%20anticipation%20and%20excitement%20mood%2C%20editorial%20photography%20style&width=1200&height=600&seq=article-2025movies-01&orientation=landscape',
    date: '2025-01-15',
    author: '影评人小王',
    relatedIds: ['art-004', 'art-005'],
  },
  {
    id: 'art-002',
    title: '《繁花》为何成为现象级热剧？深度解析',
    category: 'tv',
    summary: '王家卫首部电视剧《繁花》播出后引发全民讨论热潮。从视觉美学到人物塑造，从时代还原到情感表达，这部作品为何能俘获众多观众的心？',
    content: [
      '《繁花》的播出，无疑是2024年中国电视剧市场最引人注目的事件之一。王家卫以其独特的影像风格，将上世纪九十年代的上海呈现得流光溢彩、韵味十足。',
      '剧中的上海既真实又梦幻。霓虹灯下的黄河路、烟雨朦胧的外滩、人声鼎沸的至真园……每一个画面都像一幅精心构图的摄影作品。这种极致的视觉美学，让观众仿佛置身于那个充满机遇与激情的年代。',
      '在人物塑造上，《繁花》同样展现出非凡功力。阿宝的成长蜕变、李李的独立坚韧、汪小姐的柔情似水……每个角色都有着丰富的内心世界，他们的喜怒哀乐牵动着观众的心弦。',
      '更深层次地，《繁花》触及了改革开放大潮中普通人的命运沉浮。在时代的洪流中，每个人都在寻找自己的位置和价值。这种对人性的深刻洞察，使得《繁花》超越了简单的年代剧范畴。',
      '《繁花》的成功，证明了优质内容永远不缺观众。它不仅是一部电视剧，更是一面映照时代的镜子。',
    ],
    image: 'https://readdy.ai/api/search-image?query=Retro%201990s%20Shanghai%20neon%20street%20at%20night%20with%20wet%20pavement%20reflecting%20colorful%20lights%2C%20nostalgic%20urban%20atmosphere%2C%20cinematic%20composition%2C%20warm%20golden%20and%20red%20tones%2C%20editorial%20photography&width=1200&height=600&seq=article-fanhua-02&orientation=landscape',
    date: '2024-12-20',
    author: '剧评人老张',
    relatedIds: ['art-003', 'art-006'],
  },
  {
    id: 'art-003',
    title: '国产悬疑剧为什么越来越好看？',
    category: 'tv',
    summary: '从《隐秘的角落》到《狂飙》，国产悬疑剧在质量上实现了质的飞跃。我们来看看这背后的原因，以及有哪些值得一看的好剧推荐。',
    content: [
      '近年来，国产悬疑剧进入了一个前所未有的黄金时代。无论是口碑还是热度，都达到了新的高度。这背后有着多方面的原因。',
      '首先是剧本质量的提升。越来越多的优秀编剧投入到悬疑题材创作中，带来了更加精巧的叙事结构和更加深刻的人物刻画。《隐秘的角落》以一个看似简单的故事，揭示了人性的复杂与幽暗。',
      '其次是制作水平的进步。精良的摄影、考究的服化道、丝丝入扣的配乐，让悬疑剧的视听体验达到了电影级别。导演们也更加注重用镜头语言来营造悬疑氛围。',
      '第三是演员阵容的升级。越来越多实力派演员加入到悬疑剧的创作中，精湛的演技为角色注入了灵魂。《狂飙》中张颂文饰演的高启强，就是一个教科书级别的反派形象。',
      '此外，平台的大力投入和观众审美水平的提高，也推动了悬疑剧市场的繁荣。可以预见，未来还会有更多优秀的国产悬疑剧与观众见面。',
    ],
    image: 'https://readdy.ai/api/search-image?query=Mysterious%20dark%20alley%20with%20single%20street%20lamp%20casting%20long%20shadows%2C%20foggy%20atmosphere%2C%20noir%20cinematic%20style%2C%20suspenseful%20mood%2C%20high%20contrast%20lighting%2C%20editorial%20photography&width=1200&height=600&seq=article-xuanyi-03&orientation=landscape',
    date: '2025-02-10',
    author: '影评人小王',
    relatedIds: ['art-002', 'art-006'],
  },
  {
    id: 'art-004',
    title: '国漫崛起之路：从《大圣归来》到《深海》',
    category: 'anime',
    summary: '十年前，一部《大圣归来》点燃了国漫的希望之火。十年后的今天，国漫已经发展到了怎样的高度？让我们回顾这段不平凡的崛起之路。',
    content: [
      '2015年《大圣归来》的上映，被许多人视为国漫崛起的起点。这部作品以精良的制作和不俗的口碑，向市场证明了国产动画电影的潜力。',
      '此后，《大鱼海棠》《白蛇：缘起》《哪吒之魔童降世》等一系列优秀作品相继问世，不断刷新着观众对国漫的认知。尤其是《哪吒》以50亿票房的成绩，将国漫推向了前所未有的高度。',
      '在技术层面，国产动画的制作水平已经达到了国际水准。无论是角色建模的精细度，还是场景渲染的真实感，都令人刮目相看。《深海》中那令人惊叹的粒子水墨效果，就是技术创新的绝佳例证。',
      '更令人欣喜的是，国漫在题材和风格上越来越多元化。从神话改编到原创故事，从中国风到国际范，国漫正在形成自己独特的美学体系。',
      '当然，国漫的发展之路仍然任重道远。但可以确定的是，国漫的黄金时代已经到来。',
    ],
    image: 'https://readdy.ai/api/search-image?query=Colorful%20Chinese%20animation%20art%20studio%20with%20sketches%20and%20concept%20art%20on%20walls%2C%20creative%20workspace%20atmosphere%2C%20warm%20natural%20light%20from%20window%2C%20artistic%20and%20inspiring%20mood%2C%20editorial%20photography&width=1200&height=600&seq=article-guoman-04&orientation=landscape',
    date: '2025-03-05',
    author: '动漫达人阿杰',
    relatedIds: ['art-001', 'art-005'],
  },
  {
    id: 'art-005',
    title: '科幻电影的中国式表达：从《流浪地球》谈起',
    category: 'movie',
    summary: '当科幻遇上中国文化，会碰撞出怎样的火花？《流浪地球》系列给了我们一个独特的答案——带着地球去流浪，这是中国人对家园最深沉的眷恋。',
    content: [
      '如果说好莱坞科幻片的核心是"逃离"，那么中国科幻电影的核心则是"守护"。《流浪地球》系列最动人的地方，不在于炫目的特效，而在于其背后深厚的文化情感。',
      '为什么是"带着地球去流浪"而不是"造飞船逃跑"？这正是中国文化中"安土重迁"思想的体现。地球不仅仅是人类赖以生存的星球，更是我们共同的精神家园。',
      '在《流浪地球2》中，这种文化表达更加深入。图恒宇为了给女儿"完整的一生"而进行的疯狂尝试，是中国人重视家庭、重视传承的极致体现。',
      '中国科幻电影正在形成自己独特的美学体系。它既有硬核的科学设定，又有温暖的人文关怀；既有宏大的宇宙视角，又有细腻的情感表达。',
      '《流浪地球3》即将到来，我们有理由相信，中国科幻电影会走得越来越远，越来越好。',
    ],
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20space%20station%20interior%20with%20Earth%20visible%20through%20large%20viewport%2C%20warm%20interior%20lighting%20contrast%20with%20cold%20space%2C%20sci-fi%20cinematic%20style%2C%20hopeful%20and%20grand%20atmosphere%2C%20editorial%20photography&width=1200&height=600&seq=article-kehuan-05&orientation=landscape',
    date: '2025-04-18',
    author: '影评人小王',
    relatedIds: ['art-001', 'art-004'],
  },
  {
    id: 'art-006',
    title: '追剧指南：近期高分电视剧推荐',
    category: 'tv',
    summary: '不知道看什么剧？别担心，这份追剧指南为你精心挑选了近期口碑最好的几部电视剧，涵盖古装、都市、悬疑等多种类型。',
    content: [
      '在信息爆炸的时代，找到一部好剧变得越来越难。我们为大家整理了近期口碑最好的几部电视剧，希望能帮你节省筛选的时间。',
      '如果你喜欢古装剧，《繁花》绝对是首选。王家卫的电影美学与上海九十年代的独特气质完美融合，每一帧都是壁纸级别的存在。',
      '悬疑爱好者不能错过《隐秘的角落》。这部剧以极其精巧的叙事结构，将一个看似简单的故事讲得扣人心弦。三位小演员的表现更是惊艳。',
      '想看现实主义题材？《狂飙》不容错过。这部剧以扫黑除恶为背景，展现了中国社会二十年来的变迁，人物塑造极为丰满。',
      '喜欢轻松治愈的可以看看《向往的生活》系列。在快节奏的都市生活中，这种慢综艺能让你找到内心的平静。',
      '好剧太多，慢慢品味。祝大家追剧愉快！',
    ],
    image: 'https://readdy.ai/api/search-image?query=Cozy%20living%20room%20with%20large%20TV%20screen%20showing%20colorful%20content%2C%20comfortable%20sofa%20with%20blankets%20and%20snacks%2C%20warm%20evening%20atmosphere%2C%20relaxing%20home%20entertainment%20scene%2C%20editorial%20photography&width=1200&height=600&seq=article-zhuiju-06&orientation=landscape',
    date: '2025-05-22',
    author: '剧评人老张',
    relatedIds: ['art-002', 'art-003'],
  },
];